export default __webpack_public_path__ + "static/media/coinland-framed.8712cdbf.png";